import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsCostEditProfile from 'lumen/components/settings/cost/edit-profile';
import type MarketSettingsCostEditController from 'lumen/controllers/market/settings/cost/edit';

interface MarketSettingsCostEditSignature {
  Args: {
    controller: MarketSettingsCostEditController;
  };
}

// A stale/unknown profile id redirects to the list from the controller's
// `loadTask` (see edit.ts) rather than rendering a not-found state here.
const MarketSettingsCostEdit: TOC<MarketSettingsCostEditSignature> = <template>
  {{#if @controller.isLoading}}
    <PrismLoadingBar />
  {{else}}
    <SettingsCostEditProfile
      @bookingWindows={{@controller.bookingWindowRows}}
      @commissionValue={{@controller.commissionValue}}
      @costError={{@controller.costError}}
      @description={{@controller.description}}
      @isSaveDisabled={{@controller.isSaveDisabled}}
      @isSaving={{@controller.saveTask.isRunning}}
      @mode={{@controller.mode}}
      @name={{@controller.name}}
      @nameError={{@controller.nameError}}
      @onAdvancedCellChange={{@controller.updateAdvancedCell}}
      @onCommissionValueChange={{@controller.updateCommissionValue}}
      @onDescriptionInput={{@controller.updateDescription}}
      @onModeChange={{@controller.updateMode}}
      @onNameInput={{@controller.updateName}}
      @onSave={{@controller.saveTask.perform}}
      @onUnitChange={{@controller.updateUnit}}
      @pageTitle={{t "settings.cost.edit_page.title"}}
      @unit={{@controller.unit}}
    />
  {{/if}}
</template>;

export default MarketSettingsCostEdit;
